export default "<agm-map (mapReady)=\"setMap($event)\"></agm-map>";